module.exports = __webpack_public_path__ + "6b9115c4966ebcf9f5dde79aac568af7.pdf";